import { stock } from '@/data/stockImages';

// Problem çözme (D). Hedef: kafe müşteri sadakati nasıl artırılır, müşteri sadakati, tekrar gelen müşteri.
export default [
  {
    t: 'p',
    text: 'Kafede müşteri sadakatini artırmanın temeli, müşterinin her gelişinde aynı deneyimi yaşamasıdır: aynı lezzette ürün, makul bekleme süresi ve tanındığını hissetmesi. Sadakat programı bu temelin üzerine eklendiğinde işe yarar; tutarsız bir ürünü ya da yavaş servisi telafi etmez. Bu yazıda müşterinin neden geri gelmediğini, bunun nasıl anlaşılacağını ve neler yapılabileceğini anlatıyoruz.',
  },
  { t: 'h2', text: 'Müşteri neden geri gelmez?' },
  {
    t: 'p',
    text: 'Geri gelmeyen müşteri genellikle şikâyet etmez; sadece bir daha gelmez. Kafelerde bunun en sık görülen sebepleri şunlardır:',
  },
  {
    t: 'list',
    items: [
      '**Tutarsız ürün:** Aynı latte bir gün iyi, ertesi gün farklı. Reçete ve hazırlık standardı olmadığında ürün, hazırlayan kişiye göre değişir.',
      '**Uzun bekleme:** Özellikle sabah saatlerinde, işe yetişmeye çalışan müşteri için birkaç dakikalık fark belirleyicidir.',
      '**Yanlış ya da unutulan sipariş:** Yoğun saatte kâğıda yazılan ya da akılda tutulan siparişte hata olasılığı artar.',
      '**Tanınmamak:** Haftada birkaç kez gelen müşterinin her seferinde ilk kez gelmiş gibi karşılanması.',
    ],
  },
  { t: 'h2', text: 'Sadakat sorununu nasıl anlarsınız?' },
  {
    t: 'p',
    text: 'Sadakati ölçmenin en doğrudan yolu, tekrar gelen müşteri oranına bakmaktır. Bunun için müşterinin tanınması gerekir; kâğıt kayıtla ya da yalnızca kasadaki satışla bu mümkün olmaz. Dijital sadakat programına kayıtlı müşteriler üzerinden şu sorulara cevap aranabilir:',
  },
  {
    t: 'list',
    items: [
      'Programa kayıtlı müşterilerin ne kadarı son bir ayda tekrar geldi?',
      'Bir müşteri ortalama kaç günde bir geliyor?',
      'Kazanılan ödüllerin ne kadarı kullanılıyor? Kullanılmıyorsa ödül ilgi çekmiyor olabilir.',
    ],
  },
  {
    t: 'p',
    text: 'Programa kayıtlı olmayan müşteriler için satış raporları dolaylı bir gösterge verir: hafta içi sabah satışlarının sabit kalması düzenli bir müşteri kitlesine, dalgalanması ise gelip geçen müşteriye işaret eder.',
  },
  { t: 'h2', text: 'Neler yapılabilir?' },
  { t: 'h3', text: 'Ürünü standartlaştırın' },
  {
    t: 'p',
    text: 'Her ürünün reçetesini ölçülü olarak yazmak ve personelin buna göre hazırlaması, tutarlılığın ilk adımıdır. Reçete aynı zamanda stok ve maliyet takibinin de temelidir; bir kez yazıldığında birden fazla işe yarar. Ayrıntısı [stok takibi](/blog/stok-takibi-nasil-yapilir) yazısında.',
  },
  { t: 'h3', text: 'Bekleme süresini kısaltın' },
  {
    t: 'img',
    img: stock('aksam-yemegi', 'Deniz manzaralı bir mekânda akşam yemeği yiyen müşteriler'),
  },
  {
    t: 'p',
    text: 'Siparişin masadan garsona, garsondan bara gidişinde geçen süre, çoğu zaman hazırlık süresinden uzundur. Siparişin girildiği anda hazırlayanın ekranına düşmesi ve yoğun saatlerde müşterinin QR menüden sipariş verebilmesi bu süreyi kısaltır. Bkz. [QR kod ile masadan sipariş](/blog/qr-kod-ile-masadan-siparis).',
  },
  { t: 'h3', text: 'Düzenli müşteriyi tanıyın' },
  {
    t: 'p',
    text: 'Düzenli müşterinin adını ve her zamanki siparişini bilmek, küçük kafelerde personelin kendiliğinden yaptığı bir şeydir. Personel değiştikçe ya da şube sayısı arttıkça bu bilgi kaybolur. Sadakat programına kayıtlı müşterinin her ziyareti kodu üzerinden kayda geçer; bu, personel değişse de devam eden bir “tanınma” sağlar.',
  },
  { t: 'h3', text: 'Sadakat programı kurun, ama sade tutun' },
  {
    t: 'img',
    img: stock('sadakat-programi', 'Sadakat kartı ve telefonda puan durumu ekranı'),
  },
  {
    t: 'p',
    text: 'Müşterinin tek cümlede anlayabileceği bir program (“her 10 kahvede 1 kahve bizden”) en iyi sonucu verir. İlk ödüle ulaşmak çok uzun sürerse müşteri programı unutur. Hangi programın işletmenize uyduğunu ve bir ödülün size neye mal olduğunu [dijital sadakat kartı ve puan sistemi](/blog/dijital-sadakat-karti-ve-puan-sistemi) yazısında örneklerle anlattık.',
  },
  { t: 'h3', text: 'Kampanyaları ölçün' },
  {
    t: 'p',
    text: 'Bir kampanyanın işe yarayıp yaramadığını görmek için başlamadan önceki ve sonraki satışları karşılaştırın. Kampanyaya bir başlangıç ve bitiş tarihi koymak, hem ölçmeyi kolaylaştırır hem de müşteride bir aciliyet hissi yaratır. İşe yaramayan kampanyayı uzatmak yerine kapatıp yenisini denemek genellikle daha verimlidir.',
  },
  {
    t: 'guide',
    image: '27-kampanyalar',
    alt: 'Kampanyalar ekranında tanımlı kampanyalar, tarih ve adet bilgileri',
    caption: 'Kampanyalar ekranı: tarih ve koşulları düzenlenebilir kampanyalar.',
  },
  { t: 'h3', text: 'Personeli programın parçası yapın' },
  {
    t: 'p',
    text: 'Sadakat programı kasada sorulmadığı sürece yayılmaz. “Sadakat kodunuz var mı?” sorusunun hesap sırasında alışkanlık hâline gelmesi, programın büyümesinde en belirleyici adımdır. Masaya ya da kasaya konan kısa bir bilgi kartı, personelin açıklama yükünü azaltır.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da sadakat' },
  {
    t: 'p',
    text: 'Tilki’de Kampanyalar ve Sadakat modülü “Entegrasyonlar” sayfasından açılır. Kampanyalar tarih ve koşullarıyla tanımlanır; müşteri Tilki Sadakat uygulamasındaki koduyla kasada tanınır, puan kazanır ve ödüllerini uygulamadan takip eder. Kurulum adımları [rehberin sadakat bölümünde](/nasil-kullanilir#sadakat).',
  },
  {
    t: 'cta',
    title: 'Düzenli müşterilerinizi tanıyın',
    text: 'Ücretsiz demo talep edin; sadakat programınızı ve ilk kampanyanızı birlikte kuralım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Küçük bir kafe için sadakat programı gerekli mi?',
    a: 'Gerekli değil ama faydalı olabilir. Küçük kafelerde düzenli müşteriler zaten tanınır; program bu ilişkiyi personel değişse de kaybolmayan bir kayda dönüştürür ve müşterinin daha sık gelmesi için somut bir sebep verir.',
  },
  {
    q: 'İndirim mi, bedava ürün mü daha etkili?',
    a: 'Bedava ürün genellikle daha verimlidir: müşteri ürünü menü fiyatıyla değerlendirir, işletmeye ise yalnızca ürün maliyetine mal olur. İndirim doğrudan cirodan düşer; bu yüzden daha yüksek harcama eşiklerine bağlanması önerilir.',
  },
  {
    q: 'Sadakat programının işe yaradığını nasıl anlarım?',
    a: 'Kayıtlı müşteri sayısının artışına, bu müşterilerin ne sıklıkla geri geldiğine ve kazanılan ödüllerin ne kadarının kullanıldığına bakın. Ödüller kullanılmıyorsa hedef çok uzak ya da ödül ilgi çekmiyor olabilir.',
  },
];
